import { IconProps } from '../icon-props-interface';
import '../icons.scss';

const IconCircleBooleanTrue = ({ color = 'var(--color-semantic-success)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12.7666" r="12" fill="#E9FAF8"/>
            <path d="M15.7852 9.58508L10.7769 14.5934L8.94873 12.7462C8.85352 12.67 8.70117 12.67 8.625 12.7462L8.07275 13.2985C7.99658 13.3746 7.99658 13.527 8.07275 13.6222L10.6245 16.1549C10.7197 16.2501 10.853 16.2501 10.9482 16.1549L16.6611 10.442C16.7373 10.3658 16.7373 10.2135 16.6611 10.1183L16.1089 9.58508C16.0327 9.48987 15.8804 9.48987 15.7852 9.58508Z"
                  fill={color}/>
        </svg>

    </div>
);

export default IconCircleBooleanTrue;
